import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, Spinner, Alert, InputGroup, Form, Button } from 'react-bootstrap';
import axiosInstance from '../../api/axiosInstance';
import { FaSearch } from 'react-icons/fa';
import ServiceCard from '../../components/ServiceCard/ServiceCard';
import colors from '../../constants/colors';

const ServicePage = () => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortOption, setSortOption] = useState('name_asc');
    
    const fetchServices = useCallback(async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('/service');
            setServices(response);
            setError(null);
        } catch (error) {
            setError('Erro ao carregar serviços. Por favor tente novamente mais tarde.');
            console.error('Error fetching services:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchServices();
    }, [fetchServices]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSortChange = (e) => {
        setSortOption(e.target.value);
    };

    const filteredServices = services.filter(service => 
        service.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedServices = [...filteredServices].sort((a, b) => {
        // Primeiro ordena por order
        if (a.order !== b.order) {
            return a.order - b.order;
        }
        // Se order for igual, ordena por nome
        if (sortOption === 'name_asc') {
            return a.name.localeCompare(b.name);
        } else if (sortOption === 'name_desc') {
            return b.name.localeCompare(a.name);
        }
        return 0;
    });

    return (
        <Container className="py-5">
            <h1 className="mb-4" style={{ color: colors.dark }}>Serviços</h1>
            
            {/* Filters and Search */}
            <Row className="mb-4">
                <Col md={6}>
                    <Form>
                        <InputGroup>
                            <Form.Control
                                type="text"
                                placeholder="Pesquisar serviços..."
                                value={searchTerm}
                                onChange={handleSearch}
                            />
                            <Button 
                                style={{ backgroundColor: colors.secondary, borderColor: colors.secondary, color: colors.light }}
                            >
                                <FaSearch />
                            </Button>
                        </InputGroup>
                    </Form>
                </Col>
                <Col md={6}>
                    <Form.Select 
                        value={sortOption}
                        onChange={handleSortChange}
                    >
                        <option value="name_asc">Nome: A-Z</option>
                        <option value="name_desc">Nome: Z-A</option>
                    </Form.Select>
                </Col>
            </Row>
            
            {/* Error Message */}
            {error && <Alert style={{ backgroundColor: colors.danger, color: colors.light, borderColor: colors.danger }}>{error}</Alert>}
            
            {/* Loading Spinner */}
            {loading ? (
                <div className="text-center my-5">
                    <Spinner animation="border" role="status" style={{ color: colors.secondary }}>
                        <span className="visually-hidden">A carregar...</span>
                    </Spinner>
                </div>
            ) : (
                <>
                    {/* Services Grid */}
                    {sortedServices.length === 0 ? (
                        <Alert style={{ backgroundColor: colors.secondary, color: colors.light, borderColor: colors.secondary }}>
                            Nenhum serviço encontrado. Tente ajustar os filtros de pesquisa.
                        </Alert>
                    ) : (
                        <Row xs={1} sm={2} md={3} lg={4} className="g-4">
                            {sortedServices.map(service => (
                                <Col key={service.id}>
                                    <ServiceCard service={service} />
                                </Col>
                            ))}
                        </Row>
                    )}
                </>
            )}
        </Container>
    );
}

export default ServicePage;